// extracted by mini-css-extract-plugin
export default {"files":"IPFile_files__JaO5o","file":"IPFile_file__YYwsH"};